"use client";

import { Suspense, useEffect, useRef } from "react";
import { usePathname, useSearchParams } from "next/navigation";

function RadarAnalyticsInner() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const sdkRef = useRef<any>(null);
  const initializedRef = useRef(false);

  useEffect(() => {
    const appKey = process.env.NEXT_PUBLIC_RADAR_APP_KEY;

    if (!appKey) {
      console.warn(
        "[RadarAnalytics] NEXT_PUBLIC_RADAR_APP_KEY is not set. Analytics disabled.",
      );
      return;
    }

    let cancelled = false;

    void import("radar-js-analytic-sdk")
      .then((mod) => {
        if (cancelled) return;

        try {
          const RADAR_MONITOR = mod.default;
          sdkRef.current = RADAR_MONITOR;

          RADAR_MONITOR.setProject(appKey, undefined, { trackForInit: true });
          RADAR_MONITOR.setDisableAutoPV();
          RADAR_MONITOR.getClickAndKeydown();

          initializedRef.current = true;
        } catch (error) {
          console.error("[RadarAnalytics] Failed to initialize:", error);
        }
      })
      .catch((error) => {
        console.error("[RadarAnalytics] Failed to load SDK:", error);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!initializedRef.current || !sdkRef.current) return;

    // 延迟执行，确保 Next.js 已完成 document.title 的更新
    const timer = setTimeout(() => {
      if (!sdkRef.current) return;

      if (typeof document !== "undefined") {
        sdkRef.current.setTitle(document.title);
      }

      sdkRef.current.getTrack({ enableMenualOnce: true });
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname, searchParams]);

  return null;
}

export function RadarAnalytics() {
  return (
    <Suspense fallback={null}>
      <RadarAnalyticsInner />
    </Suspense>
  );
}
